import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

import { useOrderInvoiceStore } from '../../model/invoice/store'
import { getBlobErrorMessage } from '../../lib/blob-response'

/** `GET /admin-api/orders/{order}/invoices/{invoice}/download` — the PDF exactly as it was saved. */
export const useOrderInvoiceDownload = async (
  orderId: string | number,
  invoiceId: number,
): Promise<Blob | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const store = useOrderInvoiceStore()
  const url = useAdminRoutes('admin.order.invoice.download', { order_id: orderId, invoice_id: invoiceId })

  store.setPreviewLoading(true)

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.get<Blob>(url, { responseType: 'blob' })

    return data
  } catch (err: unknown) {
    toast.error(await getBlobErrorMessage(err))
    return null
  } finally {
    store.setPreviewLoading(false)
  }
}
